<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="form"
        :model="queryForm.params"
        label-position="top"
        label-width="auto"
        size="small"
      >
        <div class="searchContainer">
          <el-row :gutter="10">
            <el-col :span="5">
              <!--客户名称-->
              <el-form-item :label="$t('basicData.CustomerName')" prop="customerName">
                <el-select
                  v-model="queryForm.params.customerId"
                  :loading="customerLoading"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  :remote-method="remoteSearchCustomer"
                  clearable
                  filterable
                  remote
                  style="width: 100%"
                  @visible-change="onCustomerSelectVisible"
                >
                  <el-option
                    v-for="item in customerList"
                    :key="item.id"
                    :label="`${item.customerAlias}（${item.username})`"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <!--创建日期-->
              <el-form-item :label="$t('basicData.CreationTime')">
                <el-date-picker
                  v-model="time"
                  :default-time="['00:00:00', '23:59:59']"
                  :end-placeholder="$t('GlobalSetObj.endDate')"
                  :start-placeholder="$t('GlobalSetObj.startDate')"
                  style="width: 100%"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                />
              </el-form-item>
            </el-col>
            <!--            <el-col :span="6">-->
            <!--              &lt;!&ndash;业务类型&ndash;&gt;-->
            <!--              <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">-->
            <!--                <el-select-->
            <!--                  v-model="queryForm.params.businessType"-->
            <!--                  :placeholder="$t('GlobalSetObj.pleaseChoose')"-->
            <!--                  clearable-->
            <!--                  style="width: 100%"-->
            <!--                >-->
            <!--                  <el-option-->
            <!--                    v-for="item in BUSINESS_TYPE"-->
            <!--                    :key="item.value"-->
            <!--                    :label="item.label"-->
            <!--                    :value="item.value"-->
            <!--                  />-->
            <!--                </el-select>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="6">
              <!--资金状态-->
              <el-form-item :label="$t('basicData.FundStatus')" prop="status">
                <el-select
                  v-model="queryForm.params.status"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in STATUS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('receivablePayable.PaymentSlipNumber')" label-width="120px">
                <template slot="label">
                  <el-select
                    v-model="queryForm.params.numberField"
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    clearable
                    filterable
                    style="width: 100%; height: 28px"
                  >
                    <!--订单号-->
                    <el-option :label="$t('basicData.OrderNumber')" value="order_number" />
                    <!--运单号-->
                    <el-option :label="$t('basicData.WaybillNumber')" value="waybill_number" />
                  </el-select>
                </template>
                <InputTextareaCmp
                  ref="inputTextareaRef"
                  :max-length="20000"
                  :val="searchNum"
                  @input="(_, val) => (searchNum = val)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                icon="el-icon-search" size="small" type="primary"
                @click="searchResources"
              >
                {{ $t('operationCenter.Procurar') }}
              </el-button>
              <!--重 置-->
              <el-button icon="el-icon-refresh" size="small" @click="onReset">{{ $t('basicData.reset') }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-card>

    <el-card>
      <!-- 批量修改状态 -->
      <el-button
        v-permit:remove="'btn:finance:fundManagement:fundTransactionDetails:batchStatus'"
        :disabled="!selectData.length"
        class="mb10"
        size="small"
        type="primary"
        @click="batchModifyStatus"
      >{{ $t('basicData.BatchModifyFundStatus') }}
      </el-button>

      <!-- 导出 -->
      <el-button
        v-permit:remove="'btn:finance:fundManagement:fundTransactionDetails:export'"
        size="small"
        @click="exportExcel"
      >{{ $t('receivablePayable.Export') }}
      </el-button>

      <el-table
        :key="tableKey"
        ref="table"
        :data="tableData"
        :height="tableHeightRow.height"
        border
        class="table-height"
        @selection-change="handleSelectionChange"
      >
        <el-table-column align="center" type="selection" width="55" />
        <!--序号-->
        <el-table-column :label="$t('basicData.serialNumber')" align="center" width="60px">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in columns"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <!--操作-->
        <el-table-column
          :label="$t('basicData.operate')" align="center" fixed="right"
          width="160"
        >
          <template #default="scope">
            <el-button
              v-permit:remove="'btn:finance:fundManagement:fundTransactionDetails:batchStatus'"
              icon="el-icon-edit"
              size="mini"
              type="text"
              @click="modifyStatus(scope.row)"
            >{{ $t('basicData.ModifyFundStatus') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getCurrentPage"
          @size-change="getSizePage"
        />
      </div>
    </el-card>
    <el-dialog
      :title="
        modifyMode === 'single'
          ? $t('basicData.ModifyFundStatus')
          : $t('basicData.BatchModifyFundStatus')
      "
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-select
        v-model="type"
        :placeholder="$t('GlobalSetObj.pleaseChoose')"
        clearable
        size="small"
        style="width: 100%"
      >
        <el-option
          v-for="item in STATUS"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{
          $t('basicData.Cancel')
        }}</el-button>
        <el-button size="small" type="primary" @click="batchModifyStatusConfirm">{{
          $t('basicData.determine')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import dayjs from 'dayjs';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import { BUSINESS_TYPE, columns, STATUS } from './utils';
import {
  apiFundDetailExport,
  apiFundDetailList,
  apiFundDetailUpdate,
  apiFundDetailUpdateStatus
  // prepaidCustomerPage
} from '@/api/finance/fundManagement';
import { goFinanceExportPage } from '@/utils/goExportList';
import { apiGetCustomerNewPage } from '@/api/finance/contasDeClientes';

export default {
  name: 'FundTransactionDetails',

  components: {
    InputTextareaCmp: () => import('@/views/finance/cmp/Query/InputTextareaCmp.vue')
  },

  mixins: [estimateTableHeight],

  data() {
    return {
      columns, // 表头
      BUSINESS_TYPE,
      STATUS,
      time: [dayjs().format('YYYY-MM-DD 00:00:00'), dayjs().format('YYYY-MM-DD 23:59:59')],
      searchNum: '',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          customerName: '', // 客户名称
          startTime: '', // 开始时间
          endTime: '', // 结束时间
          businessType: '',
          status: '',
          numberField: 'waybill_number',
          numberList: []
        }
      },
      selectData: [], // 勾选
      tableData: [], // 表格数据
      total: 0,
      tableKey: new Date().getTime(),
      dialogVisible: false,
      type: '',
      // 修改模式：'single' 单个 | 'batch' 批量
      modifyMode: 'batch',
      // 单个修改时的当前行
      currentRow: null,
      customerList: [],
      customerLoading: false
    };
  },

  created() {
    // 获取列表
    this.getContractPage();
    this.remoteSearchCustomer();
  },
  methods: {
    // 下拉框打开时重新加载默认列表，避免残留上次搜索结果
    onCustomerSelectVisible(visible) {
      if (visible) {
        this.remoteSearchCustomer();
      }
    },

    // 远程搜索客户名称
    remoteSearchCustomer(keyword = '') {
      this.customerLoading = true;
      apiGetCustomerNewPage({
        pageNumber: 1,
        pageSize: 10,
        params: { quickSearch: keyword || '' }
      })
        .then((res) => {
          if (res.code === 200) {
            this.customerList = res.data.records || [];
          }
        })
        .catch(() => {
          this.customerList = [];
        })
        .finally(() => {
          this.customerLoading = false;
        });
    },
    // 更新自定义栏目columns
    updateColumns(list) {
      this.$nextTick(() => {
        this.currentColumns = cloneDeep(list);
        this.tableKey = new Date().getTime();
      });
    },

    // 列表数据勾选
    handleSelectionChange(arr) {
      this.selectData = arr;
    },

    searchResources() {
      this.queryForm.pageNumber = 1;
      this.getContractPage();
    },

    // 重置
    onReset() {
      this.$refs.form.resetFields();
      this.time = [dayjs().format('YYYY-MM-DD 00:00:00'), dayjs().format('YYYY-MM-DD 23:59:59')];
      this.searchNum = '';
      this.queryForm.params = {
        numberField: 'order_number'
      };
      this.remoteSearchCustomer();
      this.getContractPage();
    },

    // 翻页
    getCurrentPage(val) {
      this.queryForm.pageNumber = val;
      this.getContractPage();
    },

    // 每页显示数量变化
    getSizePage(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getContractPage();
    },

    // 请求参数处理
    handleParams() {
      const { params } = cloneDeep(this.queryForm);
      if (this.time && this.time.length) {
        params.startTime = this.time[0];
        params.endTime = this.time[1];
      } else {
        params.startTime = '';
        params.endTime = '';
      }

      if (this.searchNum.length) {
        params.numberList = this.$refs.inputTextareaRef.getValue();
      } else {
        params.numberList = [];
      }
      return params;
    },

    // 获取列表
    getContractPage() {
      const formData = cloneDeep(this.queryForm);
      formData.params = this.handleParams();
      apiFundDetailList(formData)
        .then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.tableData = data.records || [];

            this.total = res.data.total;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 修改状态（单个）
    modifyStatus(row) {
      this.modifyMode = 'single';
      this.currentRow = row;
      this.type = '';
      this.dialogVisible = true;
    },

    // 批量修改状态
    batchModifyStatus() {
      this.modifyMode = 'batch';
      this.currentRow = null;
      this.type = '';
      this.dialogVisible = true;
    },

    // 确认修改状态（单个 / 批量共用）
    batchModifyStatusConfirm() {
      if (!this.type) {
        this.$message({
          type: 'error',
          message: this.$t('basicData.PleaseSelectStatus')
        });
        return;
      }

      // 单个修改
      if (this.modifyMode === 'single') {
        apiFundDetailUpdateStatus({
          id: this.currentRow.id,
          status: this.type
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded'));
              this.dialogVisible = false;
              this.type = '';
              this.currentRow = null;
              this.getContractPage();
            }
          })
          .catch((err) => {
            this.dialogVisible = false;
            console.error(err);
          });
        return;
      }

      // 批量修改
      const ids = this.selectData.map((item) => item.id);
      apiFundDetailUpdate({
        ids,
        status: this.type
      })
        .then((res) => {
          const { code } = res;
          if (code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded'));
            this.dialogVisible = false;
            this.type = '';
            this.getContractPage();
          }
        })
        .catch((err) => {
          this.dialogVisible = false;
          console.error(err);
        });
    },

    // 导出
    exportExcel() {
      apiFundDetailExport(this.handleParams(), false)
        .then((res) => {
          if (res.code === 200) {
            goFinanceExportPage();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  color: #fff;
  font-size: 14px;
  background-color: #da4d4d;
  padding: 8px 20px;
  border-radius: 15px;
}
</style>
